const config = require(`./config.${NODE_ENV}.js`)

export default config
